<template>
    <div id="layer" style="display: block;" v-show="isVisible">
        <div class="layer-size">
            <div class="layer-wrap">
                <div class="layer-inner" v-if="isNotEmpty(initMedia)">
                    <button class="pop-close" @click="closeSelf">닫기</button>
                    <!-- 이야기 자료 본문 이미지에서 온 경우 -->
                    <media-modal-story-in-images
                        v-if="initMedia.media_type_name == 'imageInStory'"
                        :init-data="initMedia"
                    ></media-modal-story-in-images>
                    <!-- 멀티미디어에서 온 경우 -->
                    <media-modal-contents
                        v-else
                        :init-media="initMedia"
                        :init-group-list="initGroupList"
                        :theme="theme"
                    ></media-modal-contents>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MediaModalContents from './MediaModal/MediaModalContents.vue';
import MediaModalStoryInImages from './MediaModal/MediaModalImageInStory.vue';

export default {
    components: {
        MediaModalContents, // 모달 내용
        MediaModalStoryInImages, // 이야기보기 중간에 이미지 선택시
    },
    props: {
        theme: { type: String }, // 테마 // 멀티미디어 유사자료에 필요함
    },
    data(){
        return {
            isVisible: false, // 팝업 보임여부
            initMedia: null, // (팝업이 보여줄) 멀티미디어 객체
            initGroupList: null,
        }
    },
    created(){
        // 전역 이벤트 감지
        this.$bus.$on('open-modal-popup', this.openModalPopup); // 팝업 보이기
        // [FROM] resources/js/components/MultimediaList/MediaModalContents.vue // 멀티미디어에서
        // [FROM] resources/js/components/StoryView.vue // 이야기자료 상세보기 본문+관련멀티미디어에서
    },
    methods: {
        // 미디어 모달 열기
        openModalPopup(media, initGroupList) {
            // console.log("openModalPopup-Type:", media.media_type_name);
            // console.log(media, initGroupList);
            if(this.isNotEmpty(initGroupList)) this.initGroupList = initGroupList;
            this.initMedia = media;
            // 스크롤바 숨김
            document.body.classList.add('scroll-hide-body-ie11'); 
            document.body.scroll = 'no';
            document.body.style.overflow = 'hidden';
            this.isVisible = true;
        },
        closeSelf() {
            // 스크롤바 보임
            document.body.classList.remove('scroll-hide-body-ie11');
            document.body.scroll = 'yes';
            document.body.style.overflow = 'auto';
            this.isVisible = false;
            this.initMedia = null;
        },
    }
}
</script>


<style>
.ps {
    overflow: hidden !important;
    overflow-anchor: none;
    -ms-overflow-style: none;
    touch-action: auto;
    -ms-touch-action: auto;
}

.ps__rail-x {
    background-color: #e3e5e9 !important;
    height: 5px !important;
    bottom: 0 !important;
    position: absolute;
    /* please don't change 'position' */
    opacity: 1 !important;
}

.ps__rail-y {
    background-color: #e3e5e9 !important;
    width: 5px !important;
    right: 0 !important;
    position: absolute;
    /* please don't change 'position' */
    opacity: 1 !important;
}

.ps--active-x>.ps__rail-x,
.ps--active-y>.ps__rail-y {
    display: block;
    opacity: 1 !important;
}

.ps__thumb-x {
    background-color: #999 !important;
    border-radius: 2.5px !important;
    height: 5px !important;
    /* there must be 'bottom' for ps__thumb-x */
    bottom: 0 !important;
    /* please don't change 'position' */
    position: absolute;
    opacity: 1 !important;
}

.ps__thumb-y {
    background-color: #999 !important;
    border-radius: 2.5px !important;
    width: 5px !important;
    /* there must be 'right' for ps__thumb-y */
    right: 0 !important;
    /* please don't change 'position' */
    position: absolute;
    opacity: 1 !important;
}

.ps__rail-x:hover>.ps__thumb-x,
.ps__rail-x:focus>.ps__thumb-x,
.ps__rail-x.ps--clicking .ps__thumb-x {
    background-color: #999 !important;
    height: 5px !important;
    opacity: 1 !important;
}

.ps__rail-y:hover>.ps__thumb-y,
.ps__rail-y:focus>.ps__thumb-y,
.ps__rail-y.ps--clicking .ps__thumb-y {
    background-color: #999 !important;
    width: 5px !important;
    opacity: 1 !important;
}

/* MS supports */
@supports (-ms-overflow-style: none) {
    .ps {
        overflow: auto !important;
    }
}

@media screen and (-ms-high-contrast: active),
(-ms-high-contrast: none) {
    .ps {
        overflow: auto !important;
    }
}
</style>